package com.essntl.features.itinerary.ui.all_itinerary

import com.essntl.features.client.domain.model.ClientModel
import com.essntl.features.itinerary.domain.model.ItineraryModel

sealed interface AllItineraryNavigation {
    data class Overview(val itineraryId: String) : AllItineraryNavigation

    data class EditItinerary(val itineraryId: String) : AllItineraryNavigation

    data class EditClient(
        val client: ClientModel,
        val itinerary: ItineraryModel,
    ) : AllItineraryNavigation
}